import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { CodigosInternosComponent } from './codigos-internos.component';
import { CodigosInternosEditComponent } from './codigos-internos-edit/codigos-internos-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [CodigosInternosComponent, CodigosInternosEditComponent]
})
export class CodigosInternosModule { }
